var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWorkflowIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#workflow-icon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.2 5.369c.4 0 .8.372.8.83 0 .459-.4.83-.8.83-.5 0-.9-.371-.9-.83 0-.458.4-.83.9-.83Zm-.8 3.183c-1-.339-1.7-1.264-1.7-2.353 0-1.375 1.1-2.49 2.5-2.49 1.3 0 2.5 1.115 2.5 2.49C8.7 7.288 8 8.213 7 8.552v1.798c0 .458.4.83.8.83h8.3c1.4 0 2.5 1.114 2.5 2.49v1.801c1 .342 1.7 1.265 1.7 2.349 0 1.375-1.1 2.49-2.5 2.49s-2.5-1.115-2.5-2.49c0-1.084.7-2.007 1.7-2.349V13.67c0-.459-.4-.83-.9-.83H12v2.631c.9.342 1.6 1.265 1.6 2.349 0 1.375-1.1 2.49-2.4 2.49-1.4 0-2.5-1.115-2.5-2.49 0-1.084.7-2.007 1.6-2.349V12.84H7.8c-1.3 0-2.5-1.115-2.5-2.49V8.689c0-.046 0-.092.1-.137Zm12.4 8.438c-.5 0-.8.371-.8.83 0 .458.3.83.8.83s.8-.372.8-.83c0-.459-.3-.83-.8-.83Zm-7.5.83c0-.459.4-.83.9-.83.4 0 .8.371.8.83 0 .458-.4.83-.8.83-.5 0-.9-.372-.9-.83Z",
  fill: "currentColor"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "workflow-icon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(3.5 3)",
  d: "M0 0h17v18H0z"
})))));
export default SvgWorkflowIcon;